import { jsx as _jsx } from "react/jsx-runtime";
import $ from "jquery";
import { createRoot } from "react-dom/client";
import { A11yFontWeight } from "../../components/a11y/fontWeight.js";
import { getSidebarCustomize } from "../getSidebarCustomize.js";
/**
 * Add a `A11yFontWeight` to a given set of settings and output a warning or error message
 * when a not-accessible font weight got selected. The notice is only rendered
 * to the first (`props.settings[0]`) setting.
 */ function a11yFontWeight(props) {
    const customize = getSidebarCustomize();
    customize.control(props.settings[0], (param)=>{
        let { container } = param;
        const root = createRoot($("<div />").addClass("customize-control-a11y-font-weight").appendTo(container).get(0));
        root.render(/*#__PURE__*/ _jsx(A11yFontWeight, {
            ...props
        }));
    });
}
export { a11yFontWeight };
